import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WeekDay, WEEKDAYS } from '../../../types/inventoryReminder';

interface WeekdayPickerProps {
    selectedDays: WeekDay[];
    onChange: (days: WeekDay[]) => void;
    disabled?: boolean;
}

const WeekdayPicker = ({
    selectedDays,
    onChange,
    disabled = false,
}: WeekdayPickerProps) => {
    const { t } = useTranslation();

    const handleDayToggle = (day: WeekDay) => {
        if (selectedDays.includes(day)) {
            onChange(selectedDays.filter((d) => d !== day));
        } else {
            onChange([...selectedDays, day]);
        }
    };

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {t('settings.inventoryReminder.daysOfWeek.label')}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {WEEKDAYS.map((weekday) => (
                    <FormControlLabel
                        key={weekday.value}
                        control={
                            <Checkbox
                                checked={selectedDays.includes(weekday.value)}
                                onChange={() => handleDayToggle(weekday.value)}
                                disabled={disabled}
                                size="small"
                            />
                        }
                        label={t(weekday.labelKey)}
                        sx={{
                            m: 0,
                            mr: 2,
                            '& .MuiFormControlLabel-label': {
                                fontSize: '0.875rem',
                            },
                        }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default WeekdayPicker;
